// src/typeGuards/project.guards.ts

import { Project, ProjectPreview } from '@/types/project.types';

export function isFullProject(
  project: Project | ProjectPreview | null | undefined,
): project is Project {
  if (!project) return false; // null or undefined
  if (!('sites' in project) || !('status' in project)) return false;
  return Array.isArray((project as Project).sites);
}
